import {
    FeatureTierLevel,
    FeatureTierLevelMap,
    FeatureType,
    StandardProAddOns,
} from '../types';
import { LitElement, css, html } from 'lit';
import { customElement, property, query } from 'lit/decorators';

import { Dialog } from '@material/mwc-dialog';
import { UpgradeDialogElement } from './upgrade-dialog';

@customElement('upgrade-cta')
export class UpgradeTextElement extends LitElement {
    static amplitude_callsite: string = 'Upgrade Text CTA';

    @query('#upgradeDialogComponent')
    upgradeDialogComponent!: Dialog;

    @query('#upgradeDialogInnerComponent')
    upgradeDialogInnerComponent!: UpgradeDialogElement;

    @property()
    iconSize: string = 'large';

    @property()
    text?: string = '';

    @property()
    tier?: FeatureTierLevel;

    @property()
    upgradeImg?: string;

    @property()
    feature: FeatureType = FeatureType.PrintableMap;

    // if feature changes, update the icon
    updated(changedProperties: Map<string, any>) {
        if (changedProperties.has('feature')) {
            this.getEntitlementIcon();
        }
    }

    private getEntitlementIcon() {
        this.upgradeImg = '/images/tiers/starter_small.png';
    }

    private openUpgradeDialog() {
        if (
            !FeatureTierLevelMap[this.feature].includes(FeatureTierLevel.ProBase)
        ) {
            // Anything not in Pro is a Premium feature — upsell the Premium bundle.
            this.upgradeDialogInnerComponent.addon = StandardProAddOns.HaveItAll;
        }

        this.upgradeDialogComponent?.show();
    }

    render() {
        return html`
            <div class="upgrade-area" @click="${this.openUpgradeDialog}">
                <img src="${this.upgradeImg ?? ''}" class="upgrade-cta__icon"/>
                <span class="upgrade-cta__text">
                    ${this.text}
                </span>
            </div>
            <mwc-dialog id="upgradeDialogComponent" class="dialog" hideActions>
                <modal-dialog size="md" @close="${() => this.upgradeDialogComponent?.close()}">
                    <upgrade-dialog
                        id="upgradeDialogInnerComponent"
                        slot="body"
                        .featureType="${this.feature}"
                        @close="${() => this.upgradeDialogComponent?.close()}"
                    >
                    </upgrade-dialog>
                </modal-dialog>
            </mwc-dialog>
        `;
    }

    static get styles() {
        return css`
        .upgrade-area {
            display: inline-flex;
            justify-content: flex-start;
            margin-bottom: 1rem;
            font-size: .8rem;
            line-height: 1;
            color: var(--theme-text-color);
            cursor: pointer;
        }

        .upgrade-cta__icon {
            margin-right: 5px;
            max-height: 20px;
        }

        `;
    }
}



